export default {
      id: "hammer-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#hammer",
      toString: function () {
        return this.url;
      }
    }